export const URL_API = "https://www.educaciondigital.gt:4030/";
export const ROUTE_BASE = "educaciondigital";
